import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";



export const patientAllCons: { [key: string]: InterpolationWithTheme<any> } = {
    chatHead: {
        borderRadius: "50%",
        height: "50px",
        width: "50px",
        background: "#ff2f72",
        border: "none",
        position: "fixed",
        zIndex: 2,
        left: "calc(100vw - 60px)"
    }
}